export { default } from "./AnimatedGallery";
